import React from "react";

import { Fade } from "react-awesome-reveal";

import Button from "../elements/Button";

import BuildWebsite from "../assets/images/hero/BuildWebsite.png";

export default function Hero() {
  return (
    <section className="hero items-center gap-10 pt-6 lg:pt-14">
      <div className="w-full lg:w-1/2 xl:pl-12">
        <Fade direction="up" triggerOnce>
          <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-gold-100 px-4 py-1.5 text-sm font-semibold text-maroon-800">
            Trusted Manufacturer Since Establishment
          </span>
          <h1 className="font-display text-4xl leading-tight text-maroon-900 sm:text-5xl lg:text-6xl">
            Crafted Sauces
            <br /> &amp; Condiments —
            <br />
            <span className="text-maroon-600">From Bulk Supply</span>
            <br /> to Custom Bottling
          </h1>

          <p className="mt-6 max-w-xl text-lg font-light leading-relaxed text-slate-500 sm:text-xl">
            Delivering consistent taste and quality to restaurants, retailers, and
            distributors — across India and beyond.
          </p>
        </Fade>

        <Fade direction="up" delay={250} triggerOnce>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Button
              href="/product"
              type="link"
              className="group flex items-center gap-2 rounded-full bg-maroon-700 px-8 py-4 text-lg font-semibold text-white shadow-lg shadow-maroon-700/20 transition-colors hover:bg-maroon-800"
            >
              See Our Products
              <svg
                className="h-5 w-5 transition-transform group-hover:translate-x-1"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Button>
            <Button
              href="/contact-us"
              type="link"
              className="rounded-full border-2 border-maroon-200 px-8 py-4 text-lg font-semibold text-maroon-700 transition-colors hover:border-maroon-700 hover:bg-maroon-50"
            >
              Get a Quote
            </Button>
          </div>
        </Fade>
      </div>

      <div className="order-first flex w-full items-center justify-center py-4 lg:order-last lg:w-1/2">
        <Fade direction="up" triggerOnce>
          <div className="relative flex items-center justify-center">
            <div className="absolute inset-0 -z-10 rounded-full bg-gradient-to-br from-gold-100 via-maroon-50 to-transparent blur-2xl" />
            <img
              className="relative w-full max-w-md drop-shadow-2xl"
              src={BuildWebsite}
              alt="A selection of VR Food Products sauces, mayonnaise, garlic paste and Worcestershire sauce"
              loading="eager"
            />
          </div>
        </Fade>
      </div>
    </section>
  );
}
